module.exports = __webpack_public_path__ + "img/40.55eb0e78.svg";